import type { ReactNode } from 'react';
import { MoreVertical } from 'lucide-react';
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';

/** Menu ⋮ d'un élément (ligne de tableau, carte) ; les entrées (DropdownMenuItem) en enfants */
export function ActionsMenu({ label, children }: { label: string; children: ReactNode }) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        aria-label={label}
        className="p-2 hover:bg-slate-100 rounded-lg text-slate-400 hover:text-slate-600 transition-colors"
      >
        <MoreVertical className="w-5 h-5" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">{children}</DropdownMenuContent>
    </DropdownMenu>
  );
}

/** Menu ⋮ d'une ligne de tableau, dans sa cellule Actions */
export function RowActionsMenu({ label, children }: { label: string; children: ReactNode }) {
  return (
    <td className="px-6 py-4 text-right">
      <ActionsMenu label={label}>{children}</ActionsMenu>
    </td>
  );
}
